import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import L from 'leaflet';
import { createBaseLayer, QUEBEC_CENTER } from '@/lib/map';
const pinIcon = L.divIcon({
    className: 'ci-pick-marker',
    html: `<div style="width:26px;height:26px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);background:#298FC2;border:3px solid white;box-shadow:0 2px 8px rgba(0,0,0,0.4)"></div>`,
    iconSize: [26, 26],
    iconAnchor: [13, 26],
});
/** Petite carte où l'on clique (ou déplace l'épingle) pour situer un signalement. */
export function LocationPicker({ value, onPick, center, className }) {
    const containerRef = useRef(null);
    const mapRef = useRef(null);
    const markerRef = useRef(null);
    const onPickRef = useRef(onPick);
    onPickRef.current = onPick;
    useEffect(() => {
        if (!containerRef.current || mapRef.current)
            return;
        const start = center ? [center.latitude, center.longitude] : QUEBEC_CENTER;
        const map = L.map(containerRef.current, { zoomControl: true }).setView(start, center ? 14 : 8);
        createBaseLayer().addTo(map);
        map.on('click', (e) => onPickRef.current({ latitude: e.latlng.lat, longitude: e.latlng.lng }));
        mapRef.current = map;
        const ro = new ResizeObserver(() => map.invalidateSize());
        ro.observe(containerRef.current);
        return () => {
            ro.disconnect();
            map.remove();
            mapRef.current = null;
            markerRef.current = null;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        const map = mapRef.current;
        if (!map)
            return;
        if (!value) {
            markerRef.current?.remove();
            markerRef.current = null;
            return;
        }
        const ll = L.latLng(value.latitude, value.longitude);
        if (!markerRef.current) {
            markerRef.current = L.marker(ll, { icon: pinIcon, draggable: true }).addTo(map);
            markerRef.current.on('dragend', () => {
                const p = markerRef.current.getLatLng();
                onPickRef.current({ latitude: p.lat, longitude: p.lng });
            });
        }
        else {
            markerRef.current.setLatLng(ll);
        }
        if (!map.getBounds().pad(-0.2).contains(ll))
            map.setView(ll, Math.max(map.getZoom(), 16));
    }, [value]);
    return _jsx("div", { ref: containerRef, className: className, role: "application", "aria-label": "Carte : cliquez pour situer le signalement" });
}
//# sourceMappingURL=LocationPicker.js.map